var map = {
	"./icons/cust-arrow-upward.svg": 96049,
	"./icons/cust-assignment-late.svg": 75228,
	"./icons/cust-history.svg": 60727,
	"./icons/cust-money.svg": 71840,
	"./icons/cust-publish.svg": 50421,
	"./icons/cust-remove-circle-outline.svg": 23636
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 61519;